const $ = require('cash-dom');
const Device = require('../components/device');

const MobileMenu = {
  init() {
    // mobile menu toggler
    $('#main_nav_toggler').on('click', function (e) {
      $('.lang-curr-togglers .select-custom').removeClass('opened');
      $('#search_nav').removeClass('show');
      $('#main_nav').toggleClass('show');
      $(this).toggleClass('active');
    });

    //mobile submenu collapse
    $('#main_nav').on('click', 'li.nav-item.dropdown a', function (e) {
      if (Device.isTablet()) {
        const subMenu = $(this).next('.sub-menu');
        if (subMenu.length > 0 && !subMenu.hasClass('no-categories-menu')) {
          e.preventDefault();
        }

        $(this).parent('li').toggleClass('submenu-collapse');
      }
    });
  },
};

module.exports = MobileMenu;
